export default __webpack_public_path__ + "static/media/server-30x30.46156460.svg";